/**
 * カード配車の左右リスト幅のうち、この画面だけの値（既定幅と localStorage キー）。
 * 上下限・clamp・器への収め方は共有の components/dispatch/panelResize/panelWidth.ts。
 *
 * log_web_issues#312。/map (#299) で入れた幅可変をこの画面にも適用する。
 * 左右のパネルは /map と同じコンポーネント (ConvenienceDispatchVehicleList /
 * ConvenienceDispatchUnassignedList) なので、上下限 260〜720px はそのまま通用する。
 *
 * Why キーを /map と分ける: 既定幅が違う（/map は左 360・右 340）ので、共有すると
 * どちらかの初回表示が変わる。中央に置くものも地図とカードボードで違うため、
 * ちょうどよい左右の幅も画面ごとに変わる。
 */

/** 既定は変更前の固定値そのまま。初回表示の見た目を変えない */
// 車両カードの幅 (VehicleInfoView は width: 100%) + 行ラッパの px:1 × 2
export const DEFAULT_LEFT_PANEL_WIDTH = 320;
export const DEFAULT_RIGHT_PANEL_WIDTH = 380;

export const LEFT_PANEL_WIDTH_STORAGE_KEY = 'convenienceDispatch.leftPanelWidth';
export const RIGHT_PANEL_WIDTH_STORAGE_KEY = 'convenienceDispatch.rightPanelWidth';
